import { useCallback, useEffect, useState } from 'react';
import type { MyProfileForm } from '@dtp/membership-service-types';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { useAuth0Token } from './useAuth0Token';

interface ReturnType {
  profile: MyProfileForm | undefined;
  isLoading: boolean;
  error: boolean;
}

export const useFetchProfile = (): ReturnType => {
  const [profile, setProfile] = useState<MyProfileForm>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const { simpleToken: isSignedIn } = useAuth0Token();

  const getProfile = useCallback(async () => {
    if (isSignedIn && !isLoading) {
      setIsLoading(true);
      try {
        const response = await apiClient.get<MyProfileForm>(ApiType.apimMembershipApi, {
          url: ApiPaths[ApiType.apimMembershipApi].profile,
        });
        setIsLoading(false);
        setProfile(response.data);
        setError(false);
      } catch (e) {
        setIsLoading(false);
        setError(true);
      }
    }
  }, [isSignedIn, isLoading]);

  useEffect(() => {
    if (isSignedIn && !profile && !isLoading && !error) {
      getProfile().then();
    }
  }, [isSignedIn, profile, isLoading, error, getProfile]);

  return { profile, isLoading, error };
};
